<template>
  <div id="SectionSBTiRoadmap">
    <UIContainer class="SectionSBTiRoadmap__container">
      <SectionTitle class="SectionReviews__title">
        <template #title> Our proven roadmap to SBTi validation </template>
        <template #description>
          We map your footprint, score hazards and policy drivers, then quantify
          plausible financial impacts across short, medium, and long term. Next,
          we prioritize the few actions that change outcomes and build a
          transition plan you can actually fund and deliver.
        </template>
      </SectionTitle>

      <div class="SectionSBTiRoadmap__carousel">
        <UICarousel :items="steps">
          <template #card="{ item }">
            <RoadmapCard
              :index="(item as Step).index"
              :title="(item as Step).title"
              :description="(item as Step).description"
              :image="(item as Step).image"
              :backgroundColor="(item as Step).backgroundColor"
            />
          </template>
        </UICarousel>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import { ref } from 'vue'
import imgBaseline from '../assets/sbtiRoadmap/baseline.avif'
import imgPathway from '../assets/sbtiRoadmap/pathway.avif'
import imgSubmission from '../assets/sbtiRoadmap/submission.avif'
import imgValidation from '../assets/sbtiRoadmap/validation.avif'
import UICarousel from '@/views/components/UICarousel.vue'
import RoadmapCard from '@/views/components/cards/RoadmapCard.vue'

type Step = {
  index: number
  title: string
  description: string
  image: string
  backgroundColor?: string
}

const steps = ref<Step[]>([
  {
    index: 1,
    title: 'Baseline & feasibility',
    description: 'Assess current emissions and evaluate target feasibility.',
    image: imgBaseline,
    backgroundColor: '#FFFFFF',
  },
  {
    index: 2,
    title: 'Pathway & action plan',
    description:
      'Develop science-based targets and detailed decarbonization roadmap.',
    image: imgPathway,
    backgroundColor: '#F9F9FB',
  },
  {
    index: 3,
    title: 'Submission reports',
    description:
      'Prepare comprehensive documentation and submission materials.',
    image: imgSubmission,
    backgroundColor: '#EFF1F5',
  },
  {
    index: 4,
    title: 'Validation',
    description: 'Support through validation process and public commitment.',
    image: imgValidation,
    backgroundColor: '#DCDFEA',
  },
])
</script>

<style lang="scss" scoped>
#SectionSBTiRoadmap {
  position: relative;
  background-color: $color-white;
  padding: 5rem 0;

  .SectionSBTiRoadmap__container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .SectionReviews__title {
    max-width: 48rem;
  }

  .SectionSBTiRoadmap__carousel {
    margin-top: 2rem;
  }
}
</style>
